<template>
  <div :style="{ background: this.bgColor }" class="page-header">
    <div class="page-back" @click="goBack">
      <img v-if="!whiteIcon" src="@/assets/images/icon-back.png" alt="" />
      <img v-else src="@/assets/images/white-arrow.png" alt="" />
    </div>
    <h1 :style="{ color: this.color }">{{ title }}</h1>
    <div class="page-right">
      <slot name="headerRight"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    whiteIcon: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "",
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.page-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 750px;
  height: 88px;
  padding: 0 30px;
  position: relative;

  position: sticky;
  top: 0;
  z-index: 1000;
  background: #fff;
  .page-back {
    position: absolute;
    left: 30px;
    img {
      width: 20px;
      height: 40px;
    }
  }
  h1 {
    font-weight: 400;
    font-size: 34px;
    color: #000000;
    width: 420px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
  .page-right {
    display: flex;
    align-items: center;
    position: absolute;
    right: 30px;

    img {
      width: 44px;
      height: 44px;
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PageHeader.vue